export default __webpack_public_path__ + "static/media/Mark-4-HUD-Registration Marks.3c92b184.jpg";